import Class from './c-calendar-test';
import './c-calendar-test@';

export default Class;